// project
import { StudiesHome as View } from "@/components.studies/studies-home";

export const RunHome = {
	name: "studies",
	path: "/studies",
	component: View,
	meta: {
		title: "Studies"
	}
};